import React from 'react';
import styled from 'styled-components';
import { theme } from '..';
import Icon from '../Icon';
import Textinput from '../Textinput';

const TextFieldWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  
  .MuiTextField-root {
    margin: 0;
    div { border-radius: 10px; }
  }
`;

const IconCloseStyled = styled(Icon.Close)`
  cursor: pointer;
`;

const SearchBar = ({ handleClear, handleSearch, inputRef, placeholder }) => {
  return (
    <TextFieldWrapper>
      <Textinput
        placeholder={placeholder}
        variant='outlined'
        onChange={handleSearch}
        inputRef={inputRef}
        startIcon={<Icon.Search color={theme.colors.NEUTRAL_60} />}
        endIcon={<IconCloseStyled onClick={handleClear} size={'small'} color={theme.colors.NEUTRAL_60} />}
      />
    </TextFieldWrapper>
  );
};

SearchBar.displayName = 'SearchBar'

export default SearchBar;
